<template>
  <div class="hello">
    <div class="arrow-dark"></div>
    <div class="h2-arrow">CETTE PAGE<br/>N'EXISTE PAS</div>
    <!-- Button trigger modal -->
    <!-- ////////////// Footer Start ////////////// -->
    <app-footer></app-footer>
    <!-- ////////////// Footer End ////////////// -->
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default {
  name: 'page-not-found',
  data () {
    return {
      msg: 'Page introuvable'
    }
  },
  components: {
    'app-footer': Footer
  },
  mounted: function () {
    var self = this
    console.log('router.path', self.$router.path)
    setTimeout(function () {
      self.$router.replace('/app/home')
    }, 2000)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.hello {
  /*background-image: url(../assets/images/votre-espace-2-orange.png);*/
  /*background-position: 0 50px;*/
  /*background-repeat: no-repeat;*/
  /*width: 733px;*/
  /*min-height: 505px;*/
  /*min-height: calc(100vh - 500px);*/
  /*margin: auto;*/
  /*background-image: url(/assets/images/votre-espace-back-ground-orange.jpg);
  background-size: cover;*/
}

</style>


// WEBPACK FOOTER //
// NotFoundComponent.vue?53991f3f